import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { removeEmpty } from '@/utils/resultsHelper';
import TableHeaderAddRow from '@/components/table/TableHeaderAddRow';
import useDebounce from '@/utils/debounce';
import { states } from '@/constants/lifecycle';
import { findWithUUID } from '@/utils/uuidHelper';
import {
  addUsersGroups, fetchFilteredGroups, updateUsersGroupsToAdd, updateUsersUsergroupProperties,
} from '../actions/userUsergroups';
import UsersGroupsDropdown from '../components/UsersGroupsDropdown';

const UsersGroupsAddRow = ({
  addGroups,
  category,
  fetchData,
  filter,
  groups,
  groupsToAdd,
  readStatus,
  updateFilter,
  updateGroups,
  user,
}) => {
  const debouncedFetch = useDebounce(fetchData);

  const groupsToAddChange = (value) => {
    const userGroupItems = removeEmpty(value.map((code) => groups.find((item) => item.code === code)));
    updateGroups(category, user, userGroupItems);
  };

  const onFilterChange = useCallback((value, targetUser) => {
    updateFilter(value, targetUser);
    debouncedFetch(value, targetUser);
  }, [updateFilter, debouncedFetch]);

  return (
    <TableHeaderAddRow
      disabled={groupsToAdd?.length === 0}
      entity="user.group"
      onClick={() => addGroups(category, user, groupsToAdd)}
      colSpan={2}
    >
      <UsersGroupsDropdown
        autoFocus
        filter={filter}
        groups={groups}
        onChange={groupsToAddChange}
        onFilterChange={onFilterChange}
        readStatus={readStatus}
        text={groupsToAdd?.map((group) => group.code)}
        user={user}
      />
    </TableHeaderAddRow>
  );
};

export const mapStateToProps = ({
  auth: { role: { permissions } },
  userGroups: { userGroups: { assign: { users } } },
}, { user }) => {
  const item = findWithUUID(users.results, user.uuid) || {
    userGroups: {
      groupsToAdd: [],
      results: [],
      search: { filter: '', filteredResults: [], readStatus: states.NONE },
    },
  };
  const { results, search, groupsToAdd } = item.userGroups;
  const codes = results.map(({ code }) => code);
  const assignable = search.filteredResults.filter(({ code }) => !codes.includes(code));

  return (
    {
      allowAdd: permissions.usergroups.assign,
      allowRead: permissions.usergroups.read,
      filter: search.filter,
      groups: groupsToAdd.concat(assignable),
      groupsToAdd,
      readStatus: search.readStatus,
    }
  );
};

const mapDispatchToProps = {
  addGroups: addUsersGroups,
  fetchData: (filter, user) => fetchFilteredGroups('assign', 1, 10000, false, filter, 3, true, user),
  updateFilter: (filter, user) => updateUsersUsergroupProperties('assign', user, { search: { filter } }),
  updateGroups: updateUsersGroupsToAdd,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersGroupsAddRow);
